import { logger } from '@luna/logger';

type EventBuilder = () => Promise<void>;

export class EventQueue {
    queueFlushingPromise: Promise<void> | undefined;

    eventBuilders: EventBuilder[] = [];

    /**
     * If true, it will stop adding new events to the queues -> Ex. when logout is triggered and nothing new should be tracked
     */
    isStopped = false;

    track(event: () => Promise<void>): Promise<void> {
        if (this.isStopped) {
            return Promise.resolve();
        }

        this.eventBuilders.push(event);
        return this.flushQueue();
    }

    reset(): void {
        this.eventBuilders = [];
        this.queueFlushingPromise = undefined;
    }

    stop(): void {
        this.isStopped = true;
    }

    flushQueue(): Promise<void> {
        if (this.queueFlushingPromise) {
            return this.queueFlushingPromise.finally(() => this.flushQueue());
        }

        const eventsCopy = this.eventBuilders.splice(0, this.eventBuilders.length);

        this.queueFlushingPromise = eventsCopy
            .reduce((prev, currentEvent) => prev.then(() => currentEvent()), Promise.resolve())
            .catch((e) => logger.warn('Flushing event queue failed', e))
            .finally(() => {
                this.queueFlushingPromise = undefined;
            });

        return this.queueFlushingPromise;
    }
}
